export const StoreLogoBackgrounds = {
  Default: 'Default',
  Alternative: 'Alternative',
} as const
export type StoreLogoBackground = (typeof StoreLogoBackgrounds)[keyof typeof StoreLogoBackgrounds]

export const StoreLogoSizes = {
  Medium: 'Medium',
  Large: 'Large',
} as const
export type StoreLogoSize = (typeof StoreLogoSizes)[keyof typeof StoreLogoSizes]
